import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../../CartPage/redux/cartPageActions';
import styles from '../CartItemsMobileList.scss';
import {comment, commentEditing, price, date} from '../CartItemsTable.scss';
import TableComment from '../tableElements/TableComment';
import TableSupplier from '../tableElements/TableSupplier';
import TableItemQuantity from '../tableElements/TableItemQuantity';
import {formatCartItemText} from 'src/logic/utils.js';
import {formatCartItemDate} from '../../helpers';


export class MobileListItem extends React.Component {
  render() {
    const {item, changeItemComment, changeCartItemQuantity} = this.props;
    const {
        CartDetailId,
        Comment,
        Name,
        Description,
        DetailNum,
        Quantity,
        Price,
        AddDate,
        ChangeDate,
        State,
        Supplier } = item;
    return (
      <div className={styles.listItem}>
        <div>
          <div className={styles.title}>
            <span>
          Mitsubishi <br/><a href="#" className="link">101905626</a>
          </span>
          </div>
          <div className={styles.description}>{Name}</div>
          <div className={comment}>
            <TableComment
              editingClassName={commentEditing}
              onChange={changeItemComment.bind(this, CartDetailId)}
              comment={formatCartItemText(Comment)} />
          </div>
          <div style={{display: 'flex'}}>
            <TableSupplier {...Supplier} isRtl />
            <span className={date}>{formatCartItemDate(AddDate, ChangeDate)} дн.</span>
          </div>
        </div>
        <div>
          <TableItemQuantity
            onChange={changeCartItemQuantity}
            cartDetailId={CartDetailId}
            quantity={Quantity} />
          <div className={price}>
            {+Price * Quantity} <span className="price">&#8381;</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(MobileListItem);



/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/mobileListElements/MobileListItem.jsx
 **/